import React from 'react';
import { createUseStyles } from 'react-jss';
import { Colors, Theme } from '@app/theme';
import classnames from 'classnames';
import { Styles } from 'jss';
import mapValues from 'lodash/mapValues';
import { useTranslation } from 'react-i18next';

const useStyles = createUseStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.marginBase / 2,
  },
  iconContainer: {
    ...theme.fonts.label,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: [theme.marginBase / 4, theme.marginBase],
    borderRadius: theme.borderRadius.std,
    gap: theme.marginBase,
    position: 'relative',
  },
  title: {
    ...theme.fonts.label,
  },
  icon: {
    fontSize: theme.iconSize.small,
  },
  number: {
    ...theme.fonts.label,
  },
  lineSelect: {
    backgroundColor: theme.colors.blue,
    height: 2,
    alignSelf: 'stretch',
    borderRadius: theme.borderRadius.std,
  },
  indicator: {
    backgroundColor: 'inherit',
    width: theme.marginBase,
    height: theme.marginBase,
    borderRadius: '50%',
    position: 'absolute',
    top: -theme.marginBase / 2,
    right: -theme.marginBase / 2,
  },
}));

const useColorsStyle = createUseStyles((theme: Theme): Styles<Colors> => {
  return mapValues(theme.colorDefinitions, (def) => ({
    backgroundColor: def.muted,
    color: def.accessible,
    '& .indicator2': {
      backgroundColor: def.std,
    },
  }));
});

interface Props {
  icon?: string;
  title: string;
  color: Colors;
  indicator?: boolean;
  number?: number;
}

export const StudiesTab = ({
  icon,
  title,
  number = 0,
  color,
  indicator = false,
}: Props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const colorClasses = useColorsStyle();

  return (
    <div className={classes.container}>
      <div className={classnames(classes.iconContainer, colorClasses[color])}>
        {icon && <i className={classnames(classes.icon, icon)}></i>}
        <p>{number}</p>
        {indicator && (
          <div className={classnames(classes.indicator, 'indicator2')} />
        )}
      </div>
      <h1 className={classes.title}>{t(title)}</h1>
    </div>
  );
};
